import { render, staticRenderFns } from "./Res2.vue?vue&type=template&id=38948dfe&scoped=true&lang=pug"
import script from "./Res2.vue?vue&type=script&lang=js"
export * from "./Res2.vue?vue&type=script&lang=js"
import style0 from "./Res2.vue?vue&type=style&index=0&id=38948dfe&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38948dfe",
  null
  
)

export default component.exports